
















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ElementBgIcon extends Vue {
  @Prop({ required: true }) private color!: string;
  @Prop({ required: true }) private icon!: string;
  @Prop({ default: 30 }) private size!: number;
  @Prop({ default: 24 }) private ratio!: number;
  @Prop({ default: 56 }) private width!: number;
  @Prop({ default: 56 }) private height!: number;
  @Prop({ default: null }) private backgroundVar!: string;
  @Prop({ default: null }) private backgroundColor!: string;
  @Prop(Boolean) private inverted!: boolean;

  get _backgroundVar() {
    const c = (this.backgroundVar || this.color).split(' ');
    const s = new Option().style;
    s.color = c[0];
    if (s.color === c[0] && c.length === 1) {
      return c[0];
    } else {
      return `var(--v-${c[0]}-${c[1] ? c[1].replace('-', '') : 'lighten2'})`;
    }
  }

  get background() {
    if (this.backgroundColor) return this.backgroundColor;
    return this._backgroundVar;
  }

  get isNotLibraryIcon() {
    return /^http/.test(this.icon);
  }
}
